var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7065 5.98492H9.35156C8.79928 5.98492 8.35156 6.43264 8.35156 6.98492V19.9873C8.35156 20.5396 8.79928 20.9873 9.35156 20.9873H19.7065C20.2588 20.9873 20.7065 20.5396 20.7065 19.9873V6.98492C20.7065 6.43264 20.2588 5.98492 19.7065 5.98492Z",
    stroke: "currentColor",
    strokeWidth: 1.32374
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.059 5.71746V4.01267C18.059 3.46038 17.6113 3.01266 17.059 3.01266H5.32797C5.06755 3.01266 4.85645 3.2145 4.85645 3.46346V17.3398C4.85645 17.8921 5.30416 18.3398 5.85645 18.3398H7.68557",
    stroke: "currentColor",
    strokeWidth: 1.32374,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8809 11.2799H17.1758",
    stroke: "currentColor",
    strokeWidth: 1.32374,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8809 14.8099H17.1758",
    stroke: "currentColor",
    strokeWidth: 1.32374,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/订单管理.cc0dd749f5df3b173518f4c5293494df.svg";
export { ForwardRef as ReactComponent };